import axios from 'axios';

const ROOT_URL = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');

export const makeServerRequest = (path) => {
    return axios.get(`${ROOT_URL}/${path}`);
};

export const makeServerPost = (path, body, config) => {
    return axios.post(`${ROOT_URL}/${path}`, body, config);
};

export const makeServerPut = (path, body, config) => {
    return axios.put(`${ROOT_URL}/${path}`, body, config);
};

export const makeServerDelete = (path, body, config) => {
    return axios.delete(`${ROOT_URL}/${path}`, body, config);
};


// WEBPACK FOOTER //
// ./src/store/actions/util.js